export const types = {
  FEATURE_FLAG_DRAWER_OPEN:
    'drawers/featureFlagDrawer/FEATURE_FLAG_DRAWER_OPEN',
  FEATURE_FLAG_DRAWER_CLOSE:
    'drawers/featureFlagDrawer/FEATURE_FLAG_DRAWER_CLOSE',
};

export const featureFlagDrawer = {
  open: () => ({
    type: types.FEATURE_FLAG_DRAWER_OPEN,
  }),
  close: () => ({
    type: types.FEATURE_FLAG_DRAWER_CLOSE,
  }),
};
